const StudyUtils = {
  groupByDate: function (studies) {
    studies.sort((a, b) => {
      if (a.serviceDate + a.patId + a.accessionNo + a.pathVideo > b.serviceDate + b.patId + b.accessionNo + b.pathVideo) {
        return 1
      } else {
        if (a.serviceDate + a.patId + a.accessionNo + a.pathVideo < b.serviceDate + b.patId + b.accessionNo + b.pathVideo) {
          return -1
        } else {
          return 0
        }
      }
    })
    let studiesGroup = studies.reduce(function (groups, item) {
      let groupName = (item.patId || item.id) + item.serviceDate.substring(0, 10)
      if (!groups[groupName]) {
        let newItem = JSON.parse(JSON.stringify(item))
        newItem.accessionNoList = [item.accessionNo]
        newItem.titleList = [item.title || item.accessionNo]
        newItem.items = [item]
        groups[groupName] = newItem
      } else {
        groups[groupName].items.push(item)
        groups[groupName].accessionNoList.push(item.accessionNo)
        groups[groupName].accessionNo = groups[groupName].accessionNoList.join(', ')
        groups[groupName].titleList.push(item.title || item.accessionNo)
        // groups[groupName].title = groups[groupName].title + ' + ' + item.title.trim().split(' ')[0]
        groups[groupName].title = groups[groupName].titleList.map((title) => title.trim().split(' ')[0]).join(' + ')
        if (item.pathVideo) {
          groups[groupName].pathVideo = item.pathVideo
          groups[groupName].hashKey = item.hashKey
        }
        if (item.room) {
          groups[groupName].room = item.room
        }
      }
      return groups
    }, {})
    return Object.values(studiesGroup)
  }
}

export default StudyUtils



// WEBPACK FOOTER //
// ./src/utils/studyUtils.js